// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-tab-container {
    font-family: "Qualcomm Next", "Helvetica Neue", Helvetica, Arial, sans-serif;
    background-color: transparent;
    color: rgba(0, 0, 0, 0.85);
}

.row {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}


.multi-select {
    height: auto;
    padding: 0px;
}

.dropdown multi-select css-b62m3t-container {
    height: 20px;
}

h1 {
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    font-size: 2em;
    font-family: "Arial Regular", "Helvetica Neue", Helvetica, sans-serif;
}

p {
    font-family: "Qualcomm Next";
}

.dropdown-section {
    font-family: "Qualcomm Next";
    width: 25%;
    padding: 0px 8px;
}

.dropdown-section .dropdown {
    border: none;
    border-radius: 4px;
}

.dropdown-heading {
    color: rgb(103, 114, 132);
    font-family: "Arial Regular", "Helvetica Neue", Helvetica, sans-serif;
    font-size: 14px;
    margin-bottom: 2px;
}

.lsn-description {
    height: 67%;
}

.css-13cymwt-control {
    border-color: rgb(103, 114, 132) !important;
}

.licenseOnboardingTab-file-upload-group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width:50%;
}

.upload-file-section {
    border-color: rgb(103, 114, 132);
    border-width: 1px;
    border-radius: 4px;
    border-style: solid;
    width: 100%;
    margin: 0px 8px;
    padding: 12px 12px;
    margin-top: 24px;
}

.input-container {
    position: relative;
}

.choose-file-button {
    background-color: transparent;
    border-radius:1em;
}

.upload-icon {
    position: absolute;
    top: 72%;
    right: 10px;
    transform: translateY(-50%);
    width: 20px; /* Adjust the width as needed */
    height: 20px; /* Adjust the height as needed */
}

.submit-button {
    background-color: blue;
    color: white;
    padding: 10px;
    border: none;
    border-radius: 32px;
    cursor: pointer;
    float: left;
    font-size: 14px;
    margin-top: 1.5rem;
}

.submit-button:hover {
    background-color: #5a7ce8;
  }

.submit-button-section {
    padding: 8px;
    
}

.required-asterisk {
    color: red;
    margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/assets/OnboardLicense.css"],"names":[],"mappings":"AAAA;IACI,4EAA4E;IAC5E,6BAA6B;IAC7B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;;AAGA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,qEAAqE;AACzE;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qEAAqE;IACrE,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,WAAW,EAAE,+BAA+B;IAC5C,YAAY,EAAE,gCAAgC;AAClD;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;EAC3B;;AAEF;IACI,YAAY;;AAEhB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB","sourcesContent":[".lsn-tab-container {\n    font-family: \"Qualcomm Next\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    background-color: transparent;\n    color: rgba(0, 0, 0, 0.85);\n}\n\n.row {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n\n.multi-select {\n    height: auto;\n    padding: 0px;\n}\n\n.dropdown multi-select css-b62m3t-container {\n    height: 20px;\n}\n\nh1 {\n    color: rgba(0, 0, 0, 0.85);\n    font-weight: 500;\n    font-size: 2em;\n    font-family: \"Arial Regular\", \"Helvetica Neue\", Helvetica, sans-serif;\n}\n\np {\n    font-family: \"Qualcomm Next\";\n}\n\n.dropdown-section {\n    font-family: \"Qualcomm Next\";\n    width: 25%;\n    padding: 0px 8px;\n}\n\n.dropdown-section .dropdown {\n    border: none;\n    border-radius: 4px;\n}\n\n.dropdown-heading {\n    color: rgb(103, 114, 132);\n    font-family: \"Arial Regular\", \"Helvetica Neue\", Helvetica, sans-serif;\n    font-size: 14px;\n    margin-bottom: 2px;\n}\n\n.lsn-description {\n    height: 67%;\n}\n\n.css-13cymwt-control {\n    border-color: rgb(103, 114, 132) !important;\n}\n\n.licenseOnboardingTab-file-upload-group {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    width:50%;\n}\n\n.upload-file-section {\n    border-color: rgb(103, 114, 132);\n    border-width: 1px;\n    border-radius: 4px;\n    border-style: solid;\n    width: 100%;\n    margin: 0px 8px;\n    padding: 12px 12px;\n    margin-top: 24px;\n}\n\n.input-container {\n    position: relative;\n}\n\n.choose-file-button {\n    background-color: transparent;\n    border-radius:1em;\n}\n\n.upload-icon {\n    position: absolute;\n    top: 72%;\n    right: 10px;\n    transform: translateY(-50%);\n    width: 20px; /* Adjust the width as needed */\n    height: 20px; /* Adjust the height as needed */\n}\n\n.submit-button {\n    background-color: blue;\n    color: white;\n    padding: 10px;\n    border: none;\n    border-radius: 32px;\n    cursor: pointer;\n    float: left;\n    font-size: 14px;\n    margin-top: 1.5rem;\n}\n\n.submit-button:hover {\n    background-color: #5a7ce8;\n  }\n\n.submit-button-section {\n    padding: 8px;\n    \n}\n\n.required-asterisk {\n    color: red;\n    margin-left: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
